(function () {
  'use strict';

  if (window.OVREYA_WISHLIST_LOADED) return;

  window.OVREYA_WISHLIST_LOADED = true;

  const CONFIG =
    window.OVREYA_WISHLIST_CONFIG || {};

  const STORAGE_KEY =
    'ovreya_wishlist_v1';

  const ROOT = normalizeRoot(
    CONFIG.root ||
    (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) ||
    '/'
  );

  const FAVORITES_URL =
    CONFIG.favoritesUrl ||
    ROOT + 'pages/favoritos';

  const CURRENT_PRODUCT_HANDLE =
    CONFIG.productHandle || null;

  const CURRENT_PRODUCT_TITLE =
    CONFIG.productTitle || '';

  const DEFAULT_CURRENCY =
    CONFIG.currency ||
    (
      window.Shopify &&
      window.Shopify.currency &&
      window.Shopify.currency.active
    ) ||
    'COP';


  /* ======================================================
     SVG CORAZÓN
     ====================================================== */

  const HEART_SVG = `
    <svg
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67
        10.94 4.61a5.5 5.5 0 0 0-7.78 7.78
        L12 21.23l8.84-8.84
        a5.5 5.5 0 0 0 0-7.78z"
      ></path>
    </svg>
  `;


  /* ======================================================
     UTILIDADES
     ====================================================== */

  function normalizeRoot(root) {

    if (!root) return '/';

    return root.endsWith('/')
      ? root
      : root + '/';
  }


  function cleanHandles(items) {

    if (!Array.isArray(items)) {
      return [];
    }

    return [
      ...new Set(
        items
          .filter(function (item) {
            return (
              typeof item === 'string' &&
              item.trim() !== ''
            );
          })
          .map(function (item) {
            return item.trim();
          })
      )
    ];
  }


  /* ======================================================
     LEER FAVORITOS
     ====================================================== */

  function getFavorites() {

    try {

      const raw =
        localStorage.getItem(
          STORAGE_KEY
        );

      if (!raw) return [];

      return cleanHandles(
        JSON.parse(raw)
      );

    } catch (error) {

      console.warn(
        'No se pudieron leer los favoritos.',
        error
      );

      return [];
    }
  }


  /* ======================================================
     GUARDAR FAVORITOS
     ====================================================== */

  function saveFavorites(items) {

    const favorites =
      cleanHandles(items);

    try {

      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(favorites)
      );

    } catch (error) {

      console.warn(
        'No se pudieron guardar los favoritos.',
        error
      );
    }

    syncAll();

    document.dispatchEvent(
      new CustomEvent(
        'ovreya:wishlist:changed',
        {
          detail: {
            favorites: favorites
          }
        }
      )
    );
  }


  /* ======================================================
     COMPROBAR FAVORITO
     ====================================================== */

  function isFavorite(handle) {

    if (!handle) return false;

    return getFavorites()
      .includes(handle);
  }


  /* ======================================================
     AGREGAR / QUITAR
     ====================================================== */

  function toggleFavorite(handle) {

    if (!handle) return;

    let favorites =
      getFavorites();

    if (
      favorites.includes(handle)
    ) {

      favorites =
        favorites.filter(
          function (item) {
            return item !== handle;
          }
        );

    } else {

      favorites.push(handle);
    }

    saveFavorites(favorites);
  }


  /* ======================================================
     BOTÓN DE FAVORITOS DEL PRODUCTO
     ====================================================== */

  function injectProductButton() {

    if (
      !CURRENT_PRODUCT_HANDLE
    ) {
      return;
    }

    if (
      document.querySelector(
        '[data-ov-main-wishlist]'
      )
    ) {
      return;
    }

    const container =
      document.querySelector(
        '.product__info-container .product-form__buttons'
      ) ||
      document.querySelector(
        'product-info .product-form__buttons'
      ) ||
      document.querySelector(
        'main .product-form__buttons'
      );

    if (!container) return;

    const addButton =
      container.querySelector(
        '.product-form__submit'
      ) ||
      container.querySelector(
        'button[name="add"]'
      ) ||
      container.querySelector(
        'button[type="submit"]'
      );

    if (!addButton) return;

    const button =
      document.createElement(
        'button'
      );

    button.type = 'button';

    button.className =
      'ov-wishlist-button';

    button.dataset.ovWishlistToggle =
      '';

    button.dataset.ovMainWishlist =
      '';

    button.dataset.productHandle =
      CURRENT_PRODUCT_HANDLE;

    button.dataset.productTitle =
      CURRENT_PRODUCT_TITLE;

    button.setAttribute(
      'aria-pressed',
      'false'
    );

    button.setAttribute(
      'aria-label',
      'Agregar a favoritos'
    );

    button.setAttribute(
      'title',
      'Guardar en favoritos'
    );

    button.innerHTML =
      HEART_SVG +
      '<span class="visually-hidden">Favoritos</span>';

    addButton.insertAdjacentElement(
      'afterend',
      button
    );

    container.classList.add(
      'ov-has-wishlist'
    );
  }


  /* ======================================================
     CORAZÓN DEL ENCABEZADO
     ====================================================== */

  function injectHeaderButton() {

    if (
      document.querySelector(
        '[data-ov-wishlist-header]'
      )
    ) {
      return;
    }

    const headerIcons =
      document.querySelector(
        '.header__icons'
      ) ||
      document.querySelector(
        'header .header-icons'
      ) ||
      document.querySelector(
        'header [class*="icons"]'
      );

    if (!headerIcons) return;

    const link =
      document.createElement('a');

    link.href =
      FAVORITES_URL;

    link.className =
      'header__icon link focus-inset ov-header-wishlist';

    link.dataset.ovWishlistHeader =
      '';

    link.setAttribute(
      'aria-label',
      'Mis favoritos'
    );

    link.setAttribute(
      'title',
      'Mis favoritos'
    );

    link.innerHTML = `
      ${HEART_SVG}

      <span class="visually-hidden">
        Mis favoritos
      </span>

      <span
        class="ov-wishlist-count"
        data-ov-wishlist-count
        hidden
      >
        0
      </span>
    `;

    const cart =
      headerIcons.querySelector(
        '#cart-icon-bubble'
      ) ||
      Array.from(
        headerIcons.querySelectorAll('a')
      ).find(function (item) {

        const href =
          item.getAttribute('href') ||
          '';

        return (
          href.indexOf('/cart') !== -1
        );
      });

    if (
      cart &&
      cart.parentElement ===
        headerIcons
    ) {

      headerIcons.insertBefore(
        link,
        cart
      );

    } else {

      headerIcons.appendChild(
        link
      );
    }
  }


  /* ======================================================
     SINCRONIZAR CORAZONES
     ====================================================== */

  function syncProductButtons() {

    const favorites =
      getFavorites();

    document
      .querySelectorAll(
        '[data-ov-wishlist-toggle]'
      )
      .forEach(function (button) {

        const handle =
          button.dataset.productHandle;

        if (!handle) return;

        const active =
          favorites.includes(handle);

        const title =
          button.dataset.productTitle ||
          'este producto';

        button.classList.toggle(
          'is-active',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

        button.setAttribute(
          'aria-label',
          active
            ? 'Quitar ' +
              title +
              ' de favoritos'
            : 'Agregar ' +
              title +
              ' a favoritos'
        );

        button.setAttribute(
          'title',
          active
            ? 'Quitar de favoritos'
            : 'Guardar en favoritos'
        );
      });
  }


  /* ======================================================
     CONTADOR HEADER
     ====================================================== */

  function syncHeader() {

    const favorites =
      getFavorites();

    document
      .querySelectorAll(
        '[data-ov-wishlist-header]'
      )
      .forEach(function (button) {

        button.classList.toggle(
          'is-active',
          favorites.length > 0
        );

        const count =
          button.querySelector(
            '[data-ov-wishlist-count]'
          );

        if (!count) return;

        if (
          favorites.length > 0
        ) {

          count.hidden = false;

          count.textContent =
            favorites.length > 99
              ? '99+'
              : String(
                  favorites.length
                );

        } else {

          count.hidden = true;

          count.textContent = '0';
        }
      });
  }


  function syncAll() {

    syncProductButtons();

    syncHeader();
  }


  /* ======================================================
     FORMATEAR PRECIO
     ====================================================== */

  function formatMoney(
    cents,
    currency
  ) {

    const value =
      Number(cents || 0) / 100;

    const currentCurrency =
      currency ||
      DEFAULT_CURRENCY;

    if (
      currentCurrency === 'COP'
    ) {

      return (
        '$ ' +
        Math.round(value)
          .toLocaleString(
            'es-CO'
          ) +
        ' COP'
      );
    }

    try {

      return new Intl.NumberFormat(
        document.documentElement.lang ||
          'es-CO',
        {
          style: 'currency',
          currency:
            currentCurrency
        }
      ).format(value);

    } catch (error) {

      return (
        value.toLocaleString(
          'es-CO'
        ) +
        ' ' +
        currentCurrency
      );
    }
  }


  /* ======================================================
     NORMALIZAR IMAGEN
     ====================================================== */

  function normalizeImage(url) {

    if (!url) return '';

    if (
      url.indexOf('//') === 0
    ) {

      return 'https:' + url;
    }

    return url;
  }


  /* ======================================================
     CONSULTAR PRODUCTO SHOPIFY
     ====================================================== */

  async function fetchProduct(
    handle
  ) {

    const response =
      await fetch(
        ROOT +
          'products/' +
          encodeURIComponent(
            handle
          ) +
          '.js',
        {
          headers: {
            Accept:
              'application/json'
          }
        }
      );

    if (!response.ok) {

      throw new Error(
        'No se pudo cargar: ' +
          handle
      );
    }

    return response.json();
  }


  /* ======================================================
     CREAR TARJETA FAVORITO
     ====================================================== */

  function createFavoriteCard(
    product,
    currency
  ) {

    const card =
      document.createElement(
        'article'
      );

    card.className =
      'ov-wishlist-card';

    const productUrl =
      ROOT +
      'products/' +
      encodeURIComponent(
        product.handle
      );


    /* IMAGEN */

    const media =
      document.createElement('a');

    media.href =
      productUrl;

    media.className =
      'ov-wishlist-card__media';


    const imageUrl =
      product.featured_image ||
      (
        product.images &&
        product.images[0]
      );


    if (imageUrl) {

      const image =
        document.createElement(
          'img'
        );

      image.src =
        normalizeImage(
          imageUrl
        );

      image.alt =
        product.title || '';

      image.loading =
        'lazy';

      image.className =
        'ov-wishlist-card__image';

      media.appendChild(
        image
      );
    }


    card.appendChild(
      media
    );


    /* CONTENIDO */

    const content =
      document.createElement(
        'div'
      );

    content.className =
      'ov-wishlist-card__content';


    /* TÍTULO */

    const title =
      document.createElement(
        'a'
      );

    title.href =
      productUrl;

    title.className =
      'ov-wishlist-card__title';

    title.textContent =
      product.title ||
      'Producto';

    content.appendChild(
      title
    );


    /* PRECIO */

    const priceBox =
      document.createElement(
        'div'
      );

    priceBox.className =
      'ov-wishlist-card__price';


    const price =
      product.price_min != null
        ? product.price_min
        : product.price;


    const priceText =
      document.createElement(
        'span'
      );

    priceText.textContent =
      (
        product.price_varies
          ? 'Desde '
          : ''
      ) +
      formatMoney(
        price,
        currency
      );


    priceBox.appendChild(
      priceText
    );


    const compare =
      product.compare_at_price_min ||
      product.compare_at_price ||
      0;


    if (
      Number(compare) >
      Number(price)
    ) {

      const oldPrice =
        document.createElement(
          'span'
        );

      oldPrice.className =
        'ov-wishlist-card__compare';

      oldPrice.textContent =
        formatMoney(
          compare,
          currency
        );

      priceBox.appendChild(
        oldPrice
      );
    }


    content.appendChild(
      priceBox
    );


    /* ACCIONES */

    const actions =
      document.createElement(
        'div'
      );

    actions.className =
      'ov-wishlist-card__actions';


    const view =
      document.createElement(
        'a'
      );

    view.href =
      productUrl;

    view.className =
      'ov-wishlist-card__view';

    view.textContent =
      'Ver producto';


    const remove =
      document.createElement(
        'button'
      );

    remove.type =
      'button';

    remove.className =
      'ov-wishlist-card__remove is-active';

    remove.dataset.ovWishlistToggle =
      '';

    remove.dataset.productHandle =
      product.handle;

    remove.dataset.productTitle =
      product.title || '';

    remove.setAttribute(
      'aria-label',
      'Quitar de favoritos'
    );

    remove.innerHTML =
      HEART_SVG;


    actions.appendChild(
      view
    );

    actions.appendChild(
      remove
    );


    content.appendChild(
      actions
    );

    card.appendChild(
      content
    );

    return card;
  }


  /* ======================================================
     PÁGINA MIS FAVORITOS
     ====================================================== */

  async function renderFavoritesPage() {

    const page =
      document.getElementById(
        'ov-wishlist-page'
      );

    if (!page) return;


    const grid =
      document.getElementById(
        'ov-wishlist-grid'
      );

    const empty =
      document.getElementById(
        'ov-wishlist-empty'
      );

    const loading =
      document.getElementById(
        'ov-wishlist-loading'
      );


    if (
      !grid ||
      !empty ||
      !loading
    ) {
      return;
    }


    const favorites =
      getFavorites();


    grid.innerHTML = '';


    if (
      favorites.length === 0
    ) {

      loading.hidden = true;

      empty.hidden = false;

      return;
    }


    loading.hidden = false;

    empty.hidden = true;


    const currency =
      page.dataset.currency ||
      DEFAULT_CURRENCY;


    const results =
      await Promise.all(
        favorites.map(
          async function (handle) {

            try {

              return await fetchProduct(
                handle
              );

            } catch (error) {

              console.warn(
                error
              );

              return null;
            }
          }
        )
      );


    const products =
      results.filter(Boolean);


    loading.hidden = true;


    if (
      products.length === 0
    ) {

      empty.hidden = false;

      return;
    }


    products.forEach(
      function (product) {

        grid.appendChild(
          createFavoriteCard(
            product,
            currency
          )
        );
      }
    );


    syncProductButtons();
  }


  /* ======================================================
     CLIC CORAZÓN
     ====================================================== */

  document.addEventListener(
    'click',
    function (event) {

      const button =
        event.target.closest(
          '[data-ov-wishlist-toggle]'
        );

      if (!button) return;


      event.preventDefault();

      event.stopPropagation();


      const handle =
        button.dataset.productHandle;


      if (!handle) return;


      toggleFavorite(
        handle
      );


      if (
        document.getElementById(
          'ov-wishlist-page'
        )
      ) {

        renderFavoritesPage();
      }
    }
  );


  /* ======================================================
     INSERTAR ELEMENTOS
     ====================================================== */

  function injectAll() {

    injectProductButton();

    injectHeaderButton();

    syncAll();
  }


  /* ======================================================
     INICIO
     ====================================================== */

  function init() {

    injectAll();

    renderFavoritesPage();


    let scheduled =
      false;


    const observer =
      new MutationObserver(
        function () {

          if (scheduled) {
            return;
          }


          scheduled = true;


          requestAnimationFrame(
            function () {

              scheduled = false;

              injectAll();
            }
          );
        }
      );


    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  /* SHOPIFY THEME EDITOR */

  document.addEventListener(
    'shopify:section:load',
    function () {

      injectAll();

      renderFavoritesPage();
    }
  );


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();
  }


  /* ======================================================
     API INTERNA
     ====================================================== */

  window.OVREYA_WISHLIST = {

    get:
      getFavorites,

    toggle:
      toggleFavorite,

    sync:
      syncAll,

    render:
      renderFavoritesPage
  };

})();